import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProScheduleRequestForm のスタイル
 */
export const hotlineProScheduleRequestFormStyle = tv({
    defaultVariants: {
        fixedTextBgColor: 'white',
    },
    slots: {
        base: ['flex flex-col gap-24', 'w-full'],
        button: ['mx-auto'],
        fixedText: [textStyle({ color: 'base', size: 'sm' }), 'p-16', 'rounded-md'],
        phone: ['flex flex-col gap-8'],
        phoneInputWrap: ['w-full max-w-[332px]'],
    },
    variants: {
        fixedTextBgColor: {
            gray: {
                fixedText: ['bg-gray-75'],
            },
            white: {
                fixedText: ['bg-white'],
            },
        },
    },
});
